import React from "react";
import { useSiteContext } from "../contexts/SiteContext";

const SiteDataExample = () => {
  const {
    currentLanguageName,
    currentLanguageCode,
    changeLanguage,
    getTranslation,
    sections,
    getSection,
    loading,
  } = useSiteContext();

  const anasayfa = getSection("anasayfa"); //sayfa adı
  const testSectionData = anasayfa?.banner?.title_settings?.title_name;

  if (loading) return <div>Loading site data...</div>;

  return (
    <div style={{ padding: "20px", border: "1px solid #ccc", margin: "20px" }}>
      <h2>Site Data Example</h2>
      <p>
        <strong>Current Language:</strong> {currentLanguageName} (
        {currentLanguageCode})
      </p>
      {testSectionData} mete
      <div style={{ marginBottom: "10px" }}>
        <button
          onClick={() => changeLanguage("tr", "Türkçe", false)}
          disabled={currentLanguageCode === "tr"}
        >
          Türkçe
        </button>
        <button
          onClick={() => changeLanguage("en", "English", false)}
          disabled={currentLanguageCode === "en"}
          style={{ marginLeft: "10px" }}
        >
          English
        </button>
      </div>
      <hr />
      <h3>Example Translation</h3>
      <p>
        Key 'REQUIRED':{" "}
        {getTranslation("REQUIRED") || "Not found (using default)"}
      </p>
      <hr />
      <h3>Section Data Example </h3>
      {(() => {
        return (
          <div>
            <p>
              <strong>Raw Data:</strong>
            </p>
            <pre style={{ background: "#f0f0f0", padding: "10px" }}>
              {testSectionData
                ? JSON.stringify(testSectionData, null, 2)
                : "Section not found"}
            </pre>
            {/* Example of accessing a specific field if it existed */}
            {testSectionData && (
              <p>
                <strong>Specific Field (example):</strong>{" "}
                {testSectionData.title ||
                  testSectionData.header ||
                  "No title/header field"}
              </p>
            )}
          </div>
        );
      })()}
      <hr />
      <h3>Loaded Sections ({sections.length})</h3>
      <ul>
        {/* <p>{data.test2_model.data1}</p>
                                        <p>{data.test2_model.data2}</p> */}
        {sections.slice(0, 5).map((section, index) => (
          <li key={index}>
            {section.sectionName} ({section.sectionHandle})
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SiteDataExample;
